const systemSettings = {
  pageName: 'Configuraciones del sistema',
  templatePlaceholder: 'Seleccionar plantilla',
  templateLabel: 'Plantilla de configuración del sistema activo',
  templateDescriptions: 'Elija una plantilla del menú desplegable de arriba. La plantilla seleccionada se aplicará cuando haga clic en "Guardar".',
  switchButton: {
    label: 'Ver',
    options: {
      site: 'Sitio',
      account: 'Cuenta',
    },
  },
  toasts: {
    successfully: 'Guardado correctamente',
    error: 'Error',
  },
  toastReset: {
    successfully: 'Restaurar a la predeterminada completada correctamente',
    error: 'Restaurar a la predeterminada',
  },
  modalDelete: {
    header: 'Eliminar plantilla',
    body: '¿Está a punto de eliminar una plantilla?',
  },
  modalUnsaved: {
    header: 'Cambios no guardados',
    body: 'Los cambios hechos no se han guardado. ¿Desea continuar sin guardarlos?',
  },
  modalResetSettings: {
    header: 'Restaurar configuración predeterminada',
    body: 'Al continuar, revertirá a la configuración predeterminada, lo que ocasionará la pérdida de todos los ajustes que haya realizado',
  },
  modalDeleteError: {
    header: 'Eliminar una plantilla habilitada para la automatización',
    body: 'Está a punto de eliminar una plantilla que está vinculada a las automatizaciones. Para continuar con la eliminación, primero debe desconectarlo de las automatizaciones asociadas.',
  }
};

export default systemSettings;
